import React, { useEffect, useState, useCallback } from 'react';
import SoundManager from '../../../Sound/SoundManager';
import './ReactCaption.css';
let sr = true;
(window as any)['muted-cc'] = !sr;

const ReactCaption = (obj: any) => {
	// const [closedCaptions, setClosedCaptions] = useState(SoundManager.hiddenCaption);
	const [shouldRender, setShouldRender] = useState(sr);
	const [forceRender, setForceRender] = useState(false);

	useEffect(() => {
		let interval = setInterval(() => {
			if(obj.shouldRender) {
				let isMuted = (window as any)['muted-cc'];
				if(isMuted !== !shouldRender) {
					sr = !isMuted;
					setShouldRender(sr);
				}
			}
		}, 100)
	})

	// const closedCaptionsCallback = useCallback(
	// 	() => {
	// 		setClosedCaptions((closedCaptions: boolean) => !closedCaptions);
	// 	},
	// 	[obj],
	// );


	const onChangeValueKeyboard = (e: any) => {
		if (e.keyCode == 32 || e.keyCode == 13) { //32 - spacebar, 36 - enter
			// setShouldRender(!shouldRender);
			// sr = !sr;
			// closedCaptionsCallback();
		}
	};

	// (window as any).onRenderMuteToggle = () => {
	// 	return (
	// 		<div  style={{
	// 			width: '5%',
	// 			position: 'absolute',
	// 			top: '17%',
	// 			left: '1%',
	// 			cursor: 'pointer',
	// 			zIndex: 10,
	// 			pointerEvents: 'all'
	// 		}}
	// 		aria-label="Toggle Mute"
	// 		role="button"
	// 		id='main-last-object'
	// 		tabIndex={0}
	// 		onKeyUp={(window as any).mapDivEnterToClick}
	// 		onClick={() => {
	// 			(window as any).onToggleMute();

	// 			setForceRender(!forceRender)

	// 			if((window as any).onForceMuteButtonRerender) {
	// 				(window as any).onForceMuteButtonRerender();
	// 			}
	// 		}}>
	// 			<img className="pointer" src={(window as any).isMuted() ? process.env.PUBLIC_URL + '/assets/images/audioOff.svg' : process.env.PUBLIC_URL + '/assets/images/audioOn.svg'} />
	// 		</div>
	// 	);
	// }

	(window as any).onRenderCCToggle = () => {
		return (
			<div className="captions-icon modal-disable-select"
					tabIndex={0} 
					role='button' 
					aria-label={`Turn closed captioning ` + (shouldRender ? 'off' : 'on')} 
					id='cc-bttn' 
					style={{
						pointerEvents: 'all'
					}}
					onClick={() => {
						(window as any).CCEnabled = !(window as any).CCEnabled;
						if((window as any).forceUpdateCC) {
							(window as any).forceUpdateCC();
						}
						if((window as any).onForceCCButtonRerender) {
							(window as any).onForceCCButtonRerender();
						}

						// (window as any)['muted-cc'] = sr;
						setShouldRender(!shouldRender);
						sr = !sr;
					}}
					onKeyUp={(window as any).mapDivEnterToClick}>
					<img alt={!(window as any).CCEnabled ? 'Closed Captions (Off)' : 'Closed Captions (On)'} className="pointer" src={!(window as any).CCEnabled ? process.env.PUBLIC_URL + '/assets/images/closed-captioning-off.svg' : process.env.PUBLIC_URL + '/assets/images/closed-captioning-on.svg'} />
				</div>
		);
	}

	let renderCaption = () => {
		return (
			<>
				
				{/* {(window as any).onRenderMuteToggle()} */}
				{/* {(window as any).onRenderCCToggle()} */}
				
				{/* {obj.currentCaption && sr && !obj.isPaused && <div className="caption-container">
					{sr &&
						<div className="caption-block">
							<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}tabIndex={0} className="caption-paragraph" dangerouslySetInnerHTML={{__html: obj.currentCaption}}>
							</p>
						</div>
					}
				</div>
				} */}
			</>
		);
	};

	return (
		<>
			{renderCaption()}
		</>
	);
};

export default ReactCaption;